import React from 'react';
import {
  MetadataWrapper,
  DefaultMetaData,
} from 'components/Header/EntityMetadata/EntityMetadata';

interface ICustomListMetadata {
  metadata: string;
}

const CustomListMetadata: React.FC<ICustomListMetadata> = (props) => {
  const { metadata } = props;

  return (
    <MetadataWrapper>
      <DefaultMetaData>{metadata}</DefaultMetaData>
    </MetadataWrapper>
  );
};

export default CustomListMetadata;
